<template>
  <div class="mvideo" oncontextmenu = "return false">
    <div class="container" v-show="!isError">
      <video
        ref="videoPlayer"
        class="video-js vjs-big-play-centered"
        controlslist="nodownload"
        x5-video-player-type="h5-page"
        webkit-playsinline="true"
        playsinline="true"
      >
      </video>
    </div>
    <div class="error" v-show="isError">
      <span>网络错误，视频加载失败!!!</span>
    </div>
  </div>
</template>

<script>
import videojs from 'video.js'
import 'video.js/dist/video-js.css'
import 'videojs-landscape-fullscreen'
import { addHistory, getHistoryForId } from '../history/models/storage'
import { isAndroidOrIos } from '@/utils/index'
import { report } from '@/api/flow'
export default {
  name: 'mvideo',
  props: {
    path: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: 'video/mp4'
    },
    poster: {
      type: String,
      default: require('@/assets/poster.jpg')
    },
    resourInfo: { // 播放资源信息
      type: Object,
      default: function() {
        return {}
      }
    }
  },
  created () {
  },
  data () {
    return {
      video: null,
      isReady: false,
      playModel: 0, // 0 完整播放 1 试看
      endTime: 0, // 试看几秒
      isError: false,
      playHistory: {},
      needUpPlay: true
    }
  },
  watch: {
    path() {
      if(!this.path){
        return
      }
      this.video.reset()
      this.video.poster(this.poster)
      this.video.src({type: this.type, src: this.path})
    },
    resourInfo() {
      this.needUpPlay = true
    }
  },
  mounted() {
    this.resetPlayHistoryInfo()
    this.init().then(()=>{
    })
  },
  beforeDestroy() {
    if (this.player) {
      this.player.dispose()
    }
  },
  methods: {
    resetPlayHistoryInfo() {
      if(this.resourInfo && this.resourInfo.hasOwnProperty('albumId')){
        this.playHistory = getHistoryForId(this.resourInfo.albumId)
      }else{
        this.playHistory = {}
      }
    },
    init() {
      return new Promise((resolve, reject) => {
        this.video = videojs(this.$refs.videoPlayer,{
          //确定播放器是否具有用户可以与之交互的控件。没有控件，启动视频播放的唯一方法是使用autoplay属性或通过Player API。
          controls: true,
          //建议浏览器是否应在<video>加载元素后立即开始下载视频数据。
          preload: "auto",
          poster: this.poster,
          // 填充模式
          fill: true
        }, ()=>{
          this.isReady = true
          // 添加一个返回的按钮
          // var headBar = this.creatHeadBar(); // 创建一个div节点
          // this.video.el().appendChild(headBar);

          // 设置全屏
          // configure plugins
          this.video.landscapeFullscreen({
            fullscreen: {
              enterOnRotate: true,
              alwaysInLandscapeMode: true,
              iOS: true
            }
          })

          resolve()
        })
        
        // 监听播放结束
        this.video.on('ended', ()=>{
          this.video.exitFullscreen()
          this.$emit('ended')
        })
        // 监听时间
        this.video.on('timeupdate', ()=>{
          // if(this.playModel == 1&&this.video.currentTime() >= this.endTime){
          //   this.video.pause()
          //   this.$emit('overtured')
          // }
          addHistory(this.resourInfo.albumId, this.resourInfo.albumTitle, this.resourInfo.albumImage, this.resourInfo.playid, this.resourInfo.playTitle, this.video.duration(), this.video.currentTime())
        })
        if(isAndroidOrIos() == 'ios') {
          this.video.on('canplay', ()=>{
            //设置上次播放时间lastLearnTime(秒)
            this.setHistoryEndTime()
          })
        }else{
          this.video.on('loadedmetadata', ()=> {
            //设置上次播放时间lastLearnTime(秒)
            this.setHistoryEndTime()
          })
        }
        this.video.on('play', ()=>{
          this.reportPlayNum()
          this.$emit('onplay')
        })
        // 错误处理
        this.video.on('error', ()=>{
          console.log('error')
          this.video.errorDisplay.close()
          this.isError = true
        })
      })
    },
    creatHeadBar(){
      var back = document.createElement('span')
      back.className = 'back'
      back.innerHTML = "<img src="+require('@/assets/icon_back_white.png')+" >"
      back.addEventListener("click", ()=>{
        this.$emit('back')
      })
      var headBar = document.createElement('div');
      headBar.className = 'vjs-backcontrol-bar';
      headBar.appendChild(back)
      return headBar;
    },
    play(){
      this.isError = false
      this.playModel = 0
      if(this.isReady){
        this.video.load()
        this.$nextTick(()=>{
          addHistory(this.resourInfo.albumId, this.resourInfo.albumTitle, this.resourInfo.albumImage, this.resourInfo.playid, this.resourInfo.playTitle, 0, 0)
          this.reportPlayNum();
          this.video.play()
        })
      }
    },
    setHistoryEndTime(){
      if(this.playHistory&&this.playHistory.hasOwnProperty('playid')&&this.resourInfo.playid == this.playHistory.playid){
        this.video.currentTime(this.playHistory.remainTime)
        this.playHistory = {}
      }
    },
    stop(){
      this.video.pause()
    },
    overture(time, isplay) {
      this.isError = false
      this.playModel = 1
      this.endTime = time
      if(isplay){
        if(this.video.currentTime()>= time){
          this.video.currentTime(0)
        }
        this.$nextTick(()=>{
          addHistory(this.resourInfo.albumId, this.resourInfo.albumTitle, this.resourInfo.albumImage, this.resourInfo.playid, this.resourInfo.playTitle, 0, 0)
          this.reportPlayNum()
          this.video.play()
        })
      }
    },
    reportPlayNum(){
      if(this.needUpPlay){
        report(this.resourInfo.videoId, this.resourInfo.albumId)
      }
      this.needUpPlay = false
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.mvideo{
  position: relative;
  div.container{
    height: 100%;
  }
  .video-js{
    width: 100%;
  }
  .error {
    background-color: #000;
    position:absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    color: #999;
    font-size: 18px;
    padding-top: calc(30% - 16px);
  }
}
</style>
<style>
.video-js button{
  outline: none;
  -webkit-tap-highlight-color: rgba(255, 255, 255, 0);
}
.video-js .vjs-big-play-button{
    font-size: 2.5em;
    line-height: 2.3em;
    height: 2.5em;
    width: 2.5em;
    -webkit-border-radius: 2.5em;
    -moz-border-radius: 2.5em;
    border-radius: 2.5em;
    background-color: #73859f;
    background-color: rgba(115,133,159,.5);
    border-width: 0.15em;
    margin-top: -1.25em;
    margin-left: -1.75em;
}
/* 中间的播放箭头 */
.vjs-big-play-button .vjs-icon-placeholder {
    font-size: 1.63em;
}
/* 加载圆圈 */
.vjs-loading-spinner {
    font-size: 2.5em;
    width: 2em;
    height: 2em;
    border-radius: 1em;
    margin-top: -1em;
    margin-left: -1.5em;
}
.vjs-backcontrol-bar {
  display: flex;
  position: absolute; 
  top: 0;
  left: 0;
  right: 0;
  text-align: left;
  padding: 6px 10px;
  opacity: 1;
  transition: visibility 0.1s, opacity 0.1s;
}
.vjs-backcontrol-bar .back img{
  width: 32px;
  height: 32px;
}
.vjs-has-started.vjs-user-inactive.vjs-playing .vjs-backcontrol-bar {
    visibility: visible;
    opacity: 0;
    -webkit-transition: visibility 1s, opacity 1s;
    transition: visibility 1s, opacity 1s;
}
*::-webkit-media-controls-panel {
  display: none!important;
  -webkit-appearance: none;
}
*::--webkit-media-controls-play-button {
  display: none!important;
  -webkit-appearance: none;
}
*::-webkit-media-controls-start-playback-button {
  display: none!important;
  -webkit-appearance: none;
}
</style>
